import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass";
import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as React from 'react';

var isCheckBoxInput = function isCheckBoxInput(element) {
  return element.type === 'checkbox';
};

var isNullOrUndefined = function isNullOrUndefined(value) {
  return value == null;
};

var isObjectType = function isObjectType(value) {
  return typeof value === 'object';
};

var isObject = function isObject(value) {
  return !isNullOrUndefined(value) && !Array.isArray(value) && isObjectType(value) && !(value instanceof Date);
};

var getControllerValue = function getControllerValue(event) {
  return isObject(event) && event.target ? isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
};

var getNodeParentName = function getNodeParentName(name) {
  return name.substring(0, name.search(/.\d/)) || name;
};

var isNameInFieldArray = function isNameInFieldArray(names, name) {
  return _toConsumableArray(names).some(function (current) {
    return getNodeParentName(name) === current;
  });
};

var compact = function compact(value) {
  return value.filter(Boolean);
};

var isUndefined = function isUndefined(val) {
  return val === undefined;
};

var _get = function get() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var path = arguments.length > 1 ? arguments[1] : undefined;
  var defaultValue = arguments.length > 2 ? arguments[2] : undefined;
  var result = compact(path.split(/[,[\].]+?/)).reduce(function (result, key) {
    return isNullOrUndefined(result) ? result : result[key];
  }, obj);
  return isUndefined(result) || result === obj ? isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};

var EVENTS = {
  BLUR: 'blur',
  CHANGE: 'change'
};
var VALIDATION_MODE = {
  onBlur: 'onBlur',
  onChange: 'onChange',
  onSubmit: 'onSubmit',
  onTouched: 'onTouched',
  all: 'all'
};
var SELECT = 'select';
var UNDEFINED = 'undefined';
var INPUT_VALIDATION_RULES = {
  max: 'max',
  min: 'min',
  maxLength: 'maxLength',
  minLength: 'minLength',
  pattern: 'pattern',
  required: 'required',
  validate: 'validate'
};

var omit = function omit(source, key) {
  var copy = Object.assign({}, source);
  delete copy[key];
  return copy;
};

var FormContext = React.createContext(null);
FormContext.displayName = 'RHFContext';

var useFormContext = function useFormContext() {
  return React.useContext(FormContext);
};

var FormProvider = function FormProvider(props) {
  return React.createElement(FormContext.Provider, {
    value: omit(props, 'children')
  }, props.children);
};

var getProxyFormState = function getProxyFormState(isProxyEnabled, formState, readFormStateRef, localReadFormStateRef) {
  var isRoot = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  return isProxyEnabled ? new Proxy(formState, {
    get: function get(obj, prop) {
      if (prop in obj) {
        if (readFormStateRef.current[prop] !== VALIDATION_MODE.all) {
          readFormStateRef.current[prop] = isRoot ? VALIDATION_MODE.all : true;
        }

        localReadFormStateRef && (localReadFormStateRef.current[prop] = true);
        return obj[prop];
      }

      return undefined;
    }
  }) : formState;
};

var isEmptyObject = function isEmptyObject(value) {
  return isObject(value) && !Object.keys(value).length;
};

var shouldRenderFormState = function shouldRenderFormState(formState, readFormStateRef, isRoot) {
  return isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(readFormStateRef).length || Object.keys(formState).find(function (key) {
    return readFormStateRef[key] === (isRoot ? VALIDATION_MODE.all : true);
  });
};

var isWeb = typeof window !== UNDEFINED && typeof window.HTMLElement !== UNDEFINED && typeof document !== UNDEFINED;
var isProxyEnabled = isWeb ? 'Proxy' in window : typeof Proxy !== UNDEFINED;

function useFormState(props) {
  var methods = useFormContext();

  var _ref = props && props.control || methods.control,
      formStateRef = _ref.formStateRef,
      formStateSubjectRef = _ref.formStateSubjectRef,
      readFormStateRef = _ref.readFormStateRef;

  var _React$useState = React.useState(formStateRef.current),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      formState = _React$useState2[0],
      updateFormState = _React$useState2[1];

  var readFormState = React.useRef({
    isDirty: false,
    dirtyFields: false,
    touchedFields: false,
    isValidating: false,
    isValid: false,
    errors: false
  });
  React.useEffect(function () {
    var formStateSubscription = formStateSubjectRef.current.subscribe({
      next: function next(formState) {
        shouldRenderFormState(formState, readFormState.current) && updateFormState(Object.assign(Object.assign({}, formStateRef.current), formState));
      }
    });
    return function () {
      return formStateSubscription.unsubscribe();
    };
  }, []);
  return getProxyFormState(isProxyEnabled, formState, readFormStateRef, readFormState, false);
}

function useController(_ref2) {
  var name = _ref2.name,
      rules = _ref2.rules,
      defaultValue = _ref2.defaultValue,
      control = _ref2.control;
  var methods = useFormContext();

  var _ref3 = control || methods.control,
      defaultValuesRef = _ref3.defaultValuesRef,
      register = _ref3.register,
      fieldsRef = _ref3.fieldsRef,
      fieldArrayNamesRef = _ref3.fieldArrayNamesRef,
      controllerSubjectRef = _ref3.controllerSubjectRef;

  var _register = register(name, rules),
      _onChange = _register.onChange,
      _onBlur = _register.onBlur,
      ref = _register.ref;

  var _React$useState3 = React.useState(isUndefined(_get(fieldsRef.current, name)._f.value) || isNameInFieldArray(fieldArrayNamesRef.current, name) ? isUndefined(defaultValue) ? _get(defaultValuesRef.current, name) : defaultValue : _get(fieldsRef.current, name)._f.value),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      value = _React$useState4[0],
      setInputStateValue = _React$useState4[1];

  var formState = useFormState({
    control: control || methods.control
  });
  _get(fieldsRef.current, name)._f.value = value;
  React.useEffect(function () {
    var controllerSubscription = controllerSubjectRef.current.subscribe({
      next: function next(data) {
        return (!data.name || name === data.name) && setInputStateValue(_get(data.values, name));
      }
    });
    ref({
      target: value
    });
    return function () {
      return controllerSubscription.unsubscribe();
    };
  }, [name]);
  return {
    field: {
      onChange: function onChange(event) {
        var value = getControllerValue(event);
        setInputStateValue(value);

        _onChange({
          target: {
            value: value,
            name: name
          },
          type: EVENTS.CHANGE
        });
      },
      onBlur: function onBlur() {
        _onBlur({
          target: {
            name: name
          },
          type: EVENTS.BLUR
        });
      },
      name: name,
      value: value,
      ref: ref
    },
    formState: formState,
    fieldState: Object.defineProperties({}, {
      invalid: {
        get: function get() {
          return !!_get(formState.errors, name);
        }
      },
      isDirty: {
        get: function get() {
          return !!_get(formState.dirtyFields, name);
        }
      },
      isTouched: {
        get: function get() {
          return !!_get(formState.touchedFields, name);
        }
      },
      error: {
        get: function get() {
          return _get(formState.errors, name);
        }
      }
    })
  };
}

var Controller = function Controller(props) {
  return props.render(useController(props));
};

var appendErrors = function appendErrors(name, validateAllFieldCriteria, errors, type, message) {
  return validateAllFieldCriteria ? Object.assign(Object.assign({}, errors[name]), {
    types: Object.assign(Object.assign({}, errors[name] && errors[name].types ? errors[name].types : {}), _defineProperty({}, type, message || true))
  }) : {};
};

var isKey = function isKey(value) {
  return /^\w*$/.test(value);
};

var stringToPath = function stringToPath(input) {
  return compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
};

function set(object, path, value) {
  var index = -1;
  var tempPath = isKey(path) ? [path] : stringToPath(path);
  var length = tempPath.length;
  var lastIndex = length - 1;

  while (++index < length) {
    var key = tempPath[index];
    var newValue = value;

    if (index !== lastIndex) {
      var objValue = object[key];
      newValue = isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
    }

    object[key] = newValue;
    object = object[key];
  }

  return object;
}

var focusFieldBy = function focusFieldBy(fields, callback, fieldsNames) {
  var _iterator = _createForOfIteratorHelper(fieldsNames || Object.keys(fields)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var key = _step.value;

      var field = _get(fields, key);

      if (field) {
        var _f = field._f;
        var current = omit(field, '_f');

        if (_f && callback(_f.name)) {
          if (_f.ref.focus && isUndefined(_f.ref.focus())) {
            break;
          } else if (_f.refs) {
            _f.refs[0].focus();

            break;
          }
        } else if (isObject(current)) {
          focusFieldBy(current, callback);
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
};

var getFieldsValues = function getFieldsValues(fieldsRef) {
  var defaultValuesRef = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    current: {}
  };
  var output = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  for (var name in fieldsRef.current) {
    var field = fieldsRef.current[name];

    if (field) {
      var _f = field._f;
      var current = omit(field, '_f');
      set(output, name, _f ? _f.ref.disabled || _f.refs && _f.refs.every(function (ref) {
        return ref.disabled;
      }) ? undefined : _f.value : Array.isArray(field) ? [] : {});

      if (current) {
        getFieldsValues({
          current: current
        }, defaultValuesRef, output[name]);
      }
    }
  }

  return Object.assign(Object.assign({}, defaultValuesRef.current), output);
};

var generateId = function generateId() {
  var d = typeof performance === UNDEFINED ? Date.now() : performance.now() * 1000;
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16 + d) % 16 | 0;
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
};

var mapIds = function mapIds() {
  var values = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var keyName = arguments.length > 1 ? arguments[1] : undefined;
  return values.map(function (value) {
    return Object.assign(_defineProperty({}, keyName, value && value[keyName] || generateId()), value);
  });
};

var isPrimitive = function isPrimitive(value) {
  return isNullOrUndefined(value) || !isObjectType(value);
};

function deepEqual(object1, object2, isErrorObject) {
  if (isPrimitive(object1) || isPrimitive(object2) || object1 instanceof Date || object2 instanceof Date) {
    return object1 === object2;
  }

  if (!React.isValidElement(object1)) {
    var keys1 = Object.keys(object1);
    var keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (var _i = 0, _keys = keys1; _i < _keys.length; _i++) {
      var key = _keys[_i];
      var val1 = object1[key];

      if (!(isErrorObject && key === 'ref')) {
        var val2 = object2[key];

        if ((isObject(val1) || Array.isArray(val1)) && (isObject(val2) || Array.isArray(val2)) ? !deepEqual(val1, val2, isErrorObject) : val1 !== val2) {
          return false;
        }
      }
    }
  }

  return true;
}

function deepMerge(target, source) {
  if (isPrimitive(target) || isPrimitive(source)) {
    return source;
  }

  for (var key in source) {
    var targetValue = target[key];
    var sourceValue = source[key];

    try {
      target[key] = isObject(targetValue) && isObject(sourceValue) || Array.isArray(targetValue) && Array.isArray(sourceValue) ? deepMerge(targetValue, sourceValue) : sourceValue;
    } catch (_a) {}
  }

  return target;
}

function setDirtyFields(values, defaultValues, dirtyFields, parentNode, parentName) {
  var index = -1;

  while (++index < values.length) {
    for (var key in values[index]) {
      if (Array.isArray(values[index][key])) {
        !dirtyFields[index] && (dirtyFields[index] = {});
        dirtyFields[index][key] = [];
        setDirtyFields(values[index][key], _get(defaultValues[index] || {}, key, []), dirtyFields[index][key], dirtyFields[index], key);
      } else {
        deepEqual(_get(defaultValues[index] || {}, key), values[index][key]) ? set(dirtyFields[index] || {}, key) : dirtyFields[index] = Object.assign(Object.assign({}, dirtyFields[index]), _defineProperty({}, key, true));
      }
    }

    parentNode && !dirtyFields.length && delete parentNode[parentName];
  }

  return dirtyFields;
}

var setFieldArrayDirtyFields = function setFieldArrayDirtyFields(values, defaultValues, dirtyFields) {
  return deepMerge(setDirtyFields(values, defaultValues, dirtyFields.slice(0, values.length)), setDirtyFields(defaultValues, values, dirtyFields.slice(0, values.length)));
};

function append(data, value) {
  return [].concat(_toConsumableArray(data), _toConsumableArray(Array.isArray(value) ? value : [value]));
}

var fillEmptyArray = function fillEmptyArray(value) {
  return Array.isArray(value) ? Array(value.length).fill(undefined) : undefined;
};

function insert(data, index, value) {
  return [].concat(_toConsumableArray(data.slice(0, index)), _toConsumableArray(Array.isArray(value) ? value : [value]), _toConsumableArray(data.slice(index)));
}

var moveArrayAt = function moveArrayAt(data, from, to) {
  if (Array.isArray(data)) {
    if (isUndefined(data[to])) {
      data[to] = undefined;
    }

    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
  }

  return [];
};

function prepend(data, value) {
  return [].concat(_toConsumableArray(Array.isArray(value) ? value : [value]), _toConsumableArray(data));
}

function removeAtIndexes(data, indexes) {
  var i = 0;

  var temp = _toConsumableArray(data);

  var _iterator2 = _createForOfIteratorHelper(indexes),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var index = _step2.value;
      temp.splice(index - i, 1);
      i++;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return compact(temp).length ? temp : [];
}

var removeArrayAt = function removeArrayAt(data, index) {
  return isUndefined(index) ? [] : removeAtIndexes(data, (Array.isArray(index) ? index : [index]).sort(function (a, b) {
    return a - b;
  }));
};

var swapArrayAt = function swapArrayAt(data, indexA, indexB) {
  data[indexA] = [data[indexB], data[indexB] = data[indexA]][0];
};

var isBoolean = function isBoolean(value) {
  return typeof value === 'boolean';
};

function baseGet(object, updatePath) {
  var length = updatePath.slice(0, -1).length;
  var index = 0;

  while (index < length) {
    object = isUndefined(object) ? index++ : object[updatePath[index++]];
  }

  return object;
}

function unset(object, path) {
  var updatePath = isKey(path) ? [path] : stringToPath(path);
  var childObject = updatePath.length == 1 ? object : baseGet(object, updatePath);
  var key = updatePath[updatePath.length - 1];
  var previousObjRef;

  if (childObject) {
    delete childObject[key];
  }

  for (var k = 0; k < updatePath.slice(0, -1).length; k++) {
    var index = -1;
    var objectRef = void 0;
    var currentPaths = updatePath.slice(0, -(k + 1));
    var currentPathsLength = currentPaths.length - 1;

    if (k > 0) {
      previousObjRef = object;
    }

    while (++index < currentPaths.length) {
      var item = currentPaths[index];
      objectRef = objectRef ? objectRef[item] : object[item];

      if (currentPathsLength === index && (isObject(objectRef) && isEmptyObject(objectRef) || Array.isArray(objectRef) && !objectRef.filter(function (data) {
        return isObject(data) && !isEmptyObject(data) || isBoolean(data);
      }).length)) {
        previousObjRef ? delete previousObjRef[item] : delete object[item];
      }

      previousObjRef = objectRef;
    }
  }

  return object;
}

var useFieldArray = function useFieldArray(_ref4) {
  var control = _ref4.control,
      name = _ref4.name,
      _ref4$keyName = _ref4.keyName,
      keyName = _ref4$keyName === void 0 ? 'id' : _ref4$keyName;
  var methods = useFormContext();
  var focusNameRef = React.useRef('');

  var _ref5 = control || methods.control,
      isWatchAllRef = _ref5.isWatchAllRef,
      watchFieldsRef = _ref5.watchFieldsRef,
      getFormIsDirty = _ref5.getFormIsDirty,
      watchSubjectRef = _ref5.watchSubjectRef,
      fieldArraySubjectRef = _ref5.fieldArraySubjectRef,
      fieldArrayNamesRef = _ref5.fieldArrayNamesRef,
      fieldsRef = _ref5.fieldsRef,
      defaultValuesRef = _ref5.defaultValuesRef,
      formStateRef = _ref5.formStateRef,
      formStateSubjectRef = _ref5.formStateSubjectRef,
      readFormStateRef = _ref5.readFormStateRef,
      validFieldsRef = _ref5.validFieldsRef,
      fieldsWithValidationRef = _ref5.fieldsWithValidationRef,
      fieldArrayDefaultValuesRef = _ref5.fieldArrayDefaultValuesRef;

  var _React$useState5 = React.useState(mapIds(_get(fieldArrayDefaultValuesRef.current, getNodeParentName(name)) ? _get(fieldArrayDefaultValuesRef.current, name, []) : _get(defaultValuesRef.current, name, []), keyName)),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      fields = _React$useState6[0],
      setFields = _React$useState6[1];

  set(fieldArrayDefaultValuesRef.current, name, _toConsumableArray(fields));
  fieldArrayNamesRef.current.add(name);

  var omitKey = function omitKey(fields) {
    return fields.map(function (field) {
      return omit(field || {}, keyName);
    });
  };

  var getCurrentFieldsValues = function getCurrentFieldsValues() {
    var values = _get(getFieldsValues(fieldsRef, defaultValuesRef), name, []);

    return mapIds(_get(fieldArrayDefaultValuesRef.current, name, []).map(function (item, index) {
      return Object.assign(Object.assign({}, item), values[index]);
    }), keyName);
  };

  var getFocusDetail = function getFocusDetail(index, options) {
    return options ? !isUndefined(options.focusIndex) ? "".concat(name, ".").concat(options.focusIndex) : options.focusName ? options.focusName : !options.shouldFocus ? '' : "".concat(name, ".").concat(index) : "".concat(name, ".").concat(index);
  };

  var resetFields = function resetFields(index) {
    return (Array.isArray(index) ? index : [index]).forEach(function (currentIndex) {
      return set(fieldsRef.current, "".concat(name).concat(isUndefined(currentIndex) ? '' : ".".concat(currentIndex)), isUndefined(currentIndex) ? [] : undefined);
    });
  };

  var setFieldsAndNotify = function setFieldsAndNotify() {
    var fieldsValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return setFields(mapIds(fieldsValues, keyName));
  };

  var cleanup = function cleanup(ref) {
    return !compact(_get(ref, name, [])).length && unset(ref, name);
  };

  var updateDirtyFieldsWithDefaultValues = function updateDirtyFieldsWithDefaultValues(updatedFieldArrayValues) {
    return updatedFieldArrayValues && set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFieldArrayValues), _get(defaultValuesRef.current, name, []), _get(formStateRef.current.dirtyFields, name, [])));
  };

  var batchStateUpdate = function batchStateUpdate(method, args) {
    var updatedFieldArrayValues = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var shouldSet = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (_get(fieldsRef.current, name)) {
      var output = method(_get(fieldsRef.current, name), args.argA, args.argB);
      shouldSet && set(fieldsRef.current, name, output);
    }

    if (Array.isArray(_get(formStateRef.current.errors, name))) {
      var _output = method(_get(formStateRef.current.errors, name), args.argA, args.argB);

      shouldSet && set(formStateRef.current.errors, name, _output);
      cleanup(formStateRef.current.errors);
    }

    if (readFormStateRef.current.touchedFields && _get(formStateRef.current.touchedFields, name)) {
      var _output2 = method(_get(formStateRef.current.touchedFields, name), args.argA, args.argB);

      shouldSet && set(formStateRef.current.touchedFields, name, _output2);
      cleanup(formStateRef.current.touchedFields);
    }

    if (readFormStateRef.current.dirtyFields || readFormStateRef.current.isDirty) {
      set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(omitKey(updatedFieldArrayValues), _get(defaultValuesRef.current, name, []), _get(formStateRef.current.dirtyFields, name, [])));
      updateDirtyFieldsWithDefaultValues(updatedFieldArrayValues);
      cleanup(formStateRef.current.dirtyFields);
    }

    if (readFormStateRef.current.isValid) {
      set(validFieldsRef.current, name, method(_get(validFieldsRef.current, name, []), args.argA));
      cleanup(validFieldsRef.current);
      set(fieldsWithValidationRef.current, name, method(_get(fieldsWithValidationRef.current, name, []), args.argA));
      cleanup(fieldsWithValidationRef.current);
    }

    formStateSubjectRef.current.next({
      isDirty: getFormIsDirty(name, omitKey(updatedFieldArrayValues)),
      errors: formStateRef.current.errors,
      isValid: formStateRef.current.isValid
    });
  };

  var registerFieldArray = function registerFieldArray(values) {
    var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var parentName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return values.forEach(function (appendValueItem, valueIndex) {
      return !isPrimitive(appendValueItem) && Object.entries(appendValueItem).forEach(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
            key = _ref7[0],
            value = _ref7[1];

        var inputName = "".concat(parentName || name, ".").concat(parentName ? valueIndex : index + valueIndex, ".").concat(key);
        Array.isArray(value) ? registerFieldArray(value, valueIndex, inputName) : set(fieldsRef.current, inputName, {
          _f: {
            ref: {
              name: inputName
            },
            name: inputName,
            value: value
          }
        });
      });
    });
  };

  var append$1 = function append$1(value, options) {
    var appendValue = Array.isArray(value) ? value : [value];
    var updatedFieldArrayValues = append(getCurrentFieldsValues(), appendValue);
    var currentIndex = updatedFieldArrayValues.length - appendValue.length;
    setFieldsAndNotify(updatedFieldArrayValues);
    batchStateUpdate(append, {
      argA: fillEmptyArray(value)
    }, updatedFieldArrayValues, false);
    registerFieldArray(appendValue, currentIndex);
    focusNameRef.current = getFocusDetail(currentIndex, options);
  };

  var prepend$1 = function prepend$1(value, options) {
    var prependValue = Array.isArray(value) ? value : [value];
    var updatedFieldArrayValues = prepend(getCurrentFieldsValues(), prependValue);
    setFieldsAndNotify(updatedFieldArrayValues);
    batchStateUpdate(prepend, {
      argA: fillEmptyArray(value)
    }, updatedFieldArrayValues);
    registerFieldArray(prependValue);
    focusNameRef.current = getFocusDetail(0, options);
  };

  var remove = function remove(index) {
    var updatedFieldArrayValues = removeArrayAt(getCurrentFieldsValues(), index);
    resetFields(index);
    setFieldsAndNotify(updatedFieldArrayValues);
    batchStateUpdate(removeArrayAt, {
      argA: index
    }, updatedFieldArrayValues);
  };

  var insert$1 = function insert$1(index, value, options) {
    var insertValue = Array.isArray(value) ? value : [value];
    var updatedFieldArrayValues = insert(getCurrentFieldsValues(), index, insertValue);
    setFieldsAndNotify(updatedFieldArrayValues);
    batchStateUpdate(insert, {
      argA: index,
      argB: fillEmptyArray(value)
    }, updatedFieldArrayValues);
    registerFieldArray(insertValue, index);
    focusNameRef.current = getFocusDetail(index, options);
  };

  var swap = function swap(indexA, indexB) {
    var fieldValues = getCurrentFieldsValues();
    swapArrayAt(fieldValues, indexA, indexB);
    batchStateUpdate(swapArrayAt, {
      argA: indexA,
      argB: indexB
    }, fieldValues, false);
    setFieldsAndNotify(fieldValues);
  };

  var move = function move(from, to) {
    var fieldValues = getCurrentFieldsValues();
    moveArrayAt(fieldValues, from, to);
    setFieldsAndNotify(fieldValues);
    batchStateUpdate(moveArrayAt, {
      argA: from,
      argB: to
    }, fieldValues, false);
  };

  React.useEffect(function () {
    if (isWatchAllRef.current) {
      formStateSubjectRef.current.next({});
    } else {
      var _iterator3 = _createForOfIteratorHelper(watchFieldsRef.current),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var watchField = _step3.value;

          if (name.startsWith(watchField)) {
            formStateSubjectRef.current.next({});
            break;
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }

    watchSubjectRef.current.next({
      name: name,
      value: _get(getFieldsValues(fieldsRef, defaultValuesRef), name, [])
    });
    focusNameRef.current && focusFieldBy(fieldsRef.current, function (key) {
      return key.startsWith(focusNameRef.current);
    });
    focusNameRef.current = '';
    fieldArraySubjectRef.current.next({
      name: name,
      fields: omitKey(_toConsumableArray(fields))
    });
  }, [fields, name]);
  React.useEffect(function () {
    var fieldArraySubscription = fieldArraySubjectRef.current.subscribe({
      next: function next(_ref8) {
        var inputFieldArrayName = _ref8.name,
            fields = _ref8.fields,
            isReset = _ref8.isReset;

        if (isReset) {
          unset(fieldsRef.current, inputFieldArrayName || name);
          inputFieldArrayName ? set(fieldArrayDefaultValuesRef.current, inputFieldArrayName, fields) : fieldArrayDefaultValuesRef.current = fields;
          setFieldsAndNotify(_get(fieldArrayDefaultValuesRef.current, name));
        }
      }
    });
    !_get(fieldsRef.current, name) && set(fieldsRef.current, name, []);
    return function () {
      fieldArrayDefaultValuesRef.current = getFieldsValues(fieldsRef);
      fieldArraySubscription.unsubscribe();
    };
  }, []);
  return {
    swap: React.useCallback(swap, [name]),
    move: React.useCallback(move, [name]),
    prepend: React.useCallback(prepend$1, [name]),
    append: React.useCallback(append$1, [name]),
    remove: React.useCallback(remove, [name]),
    insert: React.useCallback(insert$1, [name]),
    fields: fields
  };
};

function getFields(fieldsNames, fieldsRefs) {
  var currentFields = {};

  var _iterator4 = _createForOfIteratorHelper(fieldsNames),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var name = _step4.value;

      var field = _get(fieldsRefs, name);

      if (field) {
        !isKey(name) ? set(currentFields, name, field._f) : currentFields[name] = field._f;
      }
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return currentFields;
}

var isFileInput = function isFileInput(element) {
  return element.type === 'file';
};

var isMultipleSelect = function isMultipleSelect(element) {
  return element.type === "".concat(SELECT, "-multiple");
};

var isRadioInput = function isRadioInput(element) {
  return element.type === 'radio';
};

var defaultResult = {
  value: false,
  isValid: false
};
var validResult = {
  value: true,
  isValid: true
};

var getCheckboxValue = function getCheckboxValue(options) {
  if (Array.isArray(options)) {
    if (options.length > 1) {
      var values = options.filter(function (option) {
        return option && option.checked && !option.disabled;
      }).map(function (option) {
        return option.value;
      });
      return {
        value: values,
        isValid: !!values.length
      };
    }

    return options[0].checked && !options[0].disabled ? // @ts-expect-error expected to work in the browser
    options[0].attributes && !isUndefined(options[0].attributes.value) ? isUndefined(options[0].value) || options[0].value === '' ? validResult : {
      value: options[0].value,
      isValid: true
    } : validResult : defaultResult;
  }

  return defaultResult;
};

var getFieldValueAs = function getFieldValueAs(value, _ref9) {
  var valueAsNumber = _ref9.valueAsNumber,
      valueAsDate = _ref9.valueAsDate,
      setValueAs = _ref9.setValueAs;
  return valueAsNumber ? value === '' ? NaN : +value : valueAsDate ? new Date(value) : setValueAs ? setValueAs(value) : value;
};

var getMultipleSelectValue = function getMultipleSelectValue(options) {
  return _toConsumableArray(options).filter(function (_ref10) {
    var selected = _ref10.selected;
    return selected;
  }).map(function (_ref11) {
    var value = _ref11.value;
    return value;
  });
};

var defaultReturn = {
  isValid: false,
  value: null
};

var getRadioValue = function getRadioValue(options) {
  return Array.isArray(options) ? options.reduce(function (previous, option) {
    return option && option.checked && !option.disabled ? {
      isValid: true,
      value: option.value
    } : previous;
  }, defaultReturn) : defaultReturn;
};

function getFieldValue(field) {
  if (field && field._f) {
    var ref = field._f.ref;

    if (ref.disabled) {
      return;
    }

    if (isFileInput(ref)) {
      return ref.files;
    }

    if (isRadioInput(ref)) {
      return getRadioValue(field._f.refs).value;
    }

    if (isMultipleSelect(ref)) {
      return getMultipleSelectValue(ref.options);
    }

    if (isCheckBoxInput(ref)) {
      return getCheckboxValue(field._f.refs).value;
    }

    return getFieldValueAs(isUndefined(ref.value) ? field._f.ref.value : ref.value, field._f);
  }
}

var skipValidation = function skipValidation(_ref12) {
  var isOnBlur = _ref12.isOnBlur,
      isOnChange = _ref12.isOnChange,
      isOnTouch = _ref12.isOnTouch,
      isTouched = _ref12.isTouched,
      isReValidateOnBlur = _ref12.isReValidateOnBlur,
      isReValidateOnChange = _ref12.isReValidateOnChange,
      isBlurEvent = _ref12.isBlurEvent,
      isSubmitted = _ref12.isSubmitted,
      isOnAll = _ref12.isOnAll;

  if (isOnAll) {
    return false;
  } else if (!isSubmitted && isOnTouch) {
    return !(isTouched || isBlurEvent);
  } else if (isSubmitted ? isReValidateOnBlur : isOnBlur) {
    return !isBlurEvent;
  } else if (isSubmitted ? isReValidateOnChange : isOnChange) {
    return isBlurEvent;
  }

  return true;
};

var isFunction = function isFunction(value) {
  return typeof value === 'function';
};

var isString = function isString(value) {
  return typeof value === 'string';
};

var isMessage = function isMessage(value) {
  return isString(value) || React.isValidElement(value);
};

var isRegex = function isRegex(value) {
  return value instanceof RegExp;
};

function getValidateError(result, ref) {
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'validate';

  if (isMessage(result) || isBoolean(result) && !result) {
    return {
      type: type,
      message: isMessage(result) ? result : '',
      ref: ref
    };
  }
}

var getValueAndMessage = function getValueAndMessage(validationData) {
  return isObject(validationData) && !isRegex(validationData) ? validationData : {
    value: validationData,
    message: ''
  };
};

var validateField = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref13, validateAllFieldCriteria) {
    var _ref13$_f, ref, refs, required, maxLength, minLength, min, max, pattern, validate, name, inputValue, valueAsNumber, error, isRadio, isCheckBox, isRadioOrCheckbox, isEmpty, appendErrorsCurry, getMinMaxMessage, _ref15, value, message, exceedMax, exceedMin, maxOutput, minOutput, valueNumber, valueDate, maxLengthOutput, minLengthOutput, _exceedMax, _exceedMin, _getValueAndMessage, patternValue, _message, validateRef, result, validateError, validationResult, _i2, _Object$entries, _Object$entries$_i, key, validateFunction, validateResult, _validateError;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref13$_f = _ref13._f, ref = _ref13$_f.ref, refs = _ref13$_f.refs, required = _ref13$_f.required, maxLength = _ref13$_f.maxLength, minLength = _ref13$_f.minLength, min = _ref13$_f.min, max = _ref13$_f.max, pattern = _ref13$_f.pattern, validate = _ref13$_f.validate, name = _ref13$_f.name, inputValue = _ref13$_f.value, valueAsNumber = _ref13$_f.valueAsNumber;
            error = {};
            isRadio = isRadioInput(ref);
            isCheckBox = isCheckBoxInput(ref);
            isRadioOrCheckbox = isRadio || isCheckBox;
            isEmpty = (valueAsNumber || isFileInput(ref)) && !ref.value || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
            appendErrorsCurry = appendErrors.bind(null, name, validateAllFieldCriteria, error);

            getMinMaxMessage = function getMinMaxMessage(exceedMax, maxLengthMessage, minLengthMessage) {
              var maxType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : INPUT_VALIDATION_RULES.maxLength;
              var minType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : INPUT_VALIDATION_RULES.minLength;
              var message = exceedMax ? maxLengthMessage : minLengthMessage;
              error[name] = Object.assign({
                type: exceedMax ? maxType : minType,
                message: message,
                ref: ref
              }, appendErrorsCurry(exceedMax ? maxType : minType, message));
            };

            if (!(required && (!isRadio && !isCheckBox && (isEmpty || isNullOrUndefined(inputValue)) || isBoolean(inputValue) && !inputValue || isCheckBox && !getCheckboxValue(refs).isValid || isRadio && !getRadioValue(refs).isValid))) {
              _context.next = 14;
              break;
            }

            _ref15 = isMessage(required) ? {
              value: !!required,
              message: required
            } : getValueAndMessage(required), value = _ref15.value, message = _ref15.message;

            if (!value) {
              _context.next = 14;
              break;
            }

            error[name] = Object.assign({
              type: INPUT_VALIDATION_RULES.required,
              message: message,
              ref: isRadioOrCheckbox ? (refs || [])[0] || {} : ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.required, message));

            if (validateAllFieldCriteria) {
              _context.next = 14;
              break;
            }

            return _context.abrupt("return", error);

          case 14:
            if (!((!isNullOrUndefined(min) || !isNullOrUndefined(max)) && inputValue !== '')) {
              _context.next = 22;
              break;
            }

            maxOutput = getValueAndMessage(max);
            minOutput = getValueAndMessage(min);

            if (!isNaN(inputValue)) {
              valueNumber = ref.valueAsNumber || parseFloat(inputValue);

              if (!isNullOrUndefined(maxOutput.value)) {
                exceedMax = valueNumber > maxOutput.value;
              }

              if (!isNullOrUndefined(minOutput.value)) {
                exceedMin = valueNumber < minOutput.value;
              }
            } else {
              valueDate = ref.valueAsDate || new Date(inputValue);

              if (isString(maxOutput.value)) {
                exceedMax = valueDate > new Date(maxOutput.value);
              }

              if (isString(minOutput.value)) {
                exceedMin = valueDate < new Date(minOutput.value);
              }
            }

            if (!(exceedMax || exceedMin)) {
              _context.next = 22;
              break;
            }

            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, INPUT_VALIDATION_RULES.max, INPUT_VALIDATION_RULES.min);

            if (validateAllFieldCriteria) {
              _context.next = 22;
              break;
            }

            return _context.abrupt("return", error);

          case 22:
            if (!(isString(inputValue) && !isEmpty && (maxLength || minLength))) {
              _context.next = 31;
              break;
            }

            maxLengthOutput = getValueAndMessage(maxLength);
            minLengthOutput = getValueAndMessage(minLength);
            _exceedMax = !isNullOrUndefined(maxLengthOutput.value) && inputValue.length > maxLengthOutput.value;
            _exceedMin = !isNullOrUndefined(minLengthOutput.value) && inputValue.length < minLengthOutput.value;

            if (!(_exceedMax || _exceedMin)) {
              _context.next = 31;
              break;
            }

            getMinMaxMessage(_exceedMax, maxLengthOutput.message, minLengthOutput.message);

            if (validateAllFieldCriteria) {
              _context.next = 31;
              break;
            }

            return _context.abrupt("return", error);

          case 31:
            if (!(isString(inputValue) && pattern && !isEmpty)) {
              _context.next = 37;
              break;
            }

            _getValueAndMessage = getValueAndMessage(pattern), patternValue = _getValueAndMessage.value, _message = _getValueAndMessage.message;

            if (!(isRegex(patternValue) && !inputValue.match(patternValue))) {
              _context.next = 37;
              break;
            }

            error[name] = Object.assign({
              type: INPUT_VALIDATION_RULES.pattern,
              message: _message,
              ref: ref
            }, appendErrorsCurry(INPUT_VALIDATION_RULES.pattern, _message));

            if (validateAllFieldCriteria) {
              _context.next = 37;
              break;
            }

            return _context.abrupt("return", error);

          case 37:
            if (!validate) {
              _context.next = 69;
              break;
            }

            validateRef = isRadioOrCheckbox && refs ? refs[0] : ref;

            if (!isFunction(validate)) {
              _context.next = 50;
              break;
            }

            _context.next = 42;
            return validate(inputValue);

          case 42:
            result = _context.sent;
            validateError = getValidateError(result, validateRef);

            if (!validateError) {
              _context.next = 48;
              break;
            }

            error[name] = Object.assign(Object.assign({}, validateError), appendErrorsCurry(INPUT_VALIDATION_RULES.validate, validateError.message));

            if (validateAllFieldCriteria) {
              _context.next = 48;
              break;
            }

            return _context.abrupt("return", error);

          case 48:
            _context.next = 69;
            break;

          case 50:
            if (!isObject(validate)) {
              _context.next = 69;
              break;
            }

            validationResult = {};
            _i2 = 0, _Object$entries = Object.entries(validate);

          case 53:
            if (!(_i2 < _Object$entries.length)) {
              _context.next = 65;
              break;
            }

            _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2), key = _Object$entries$_i[0], validateFunction = _Object$entries$_i[1];

            if (!(!isEmptyObject(validationResult) && !validateAllFieldCriteria)) {
              _context.next = 57;
              break;
            }

            return _context.abrupt("break", 65);

          case 57:
            _context.next = 59;
            return validateFunction(inputValue);

          case 59:
            validateResult = _context.sent;
            _validateError = getValidateError(validateResult, validateRef, key);

            if (_validateError) {
              validationResult = Object.assign(Object.assign({}, _validateError), appendErrorsCurry(key, _validateError.message));

              if (validateAllFieldCriteria) {
                error[name] = validationResult;
              }
            }

          case 62:
            _i2++;
            _context.next = 53;
            break;

          case 65:
            if (isEmptyObject(validationResult)) {
              _context.next = 69;
              break;
            }

            error[name] = Object.assign({
              ref: validateRef
            }, validationResult);

            if (validateAllFieldCriteria) {
              _context.next = 69;
              break;
            }

            return _context.abrupt("return", error);

          case 69:
            return _context.abrupt("return", error);

          case 70:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function validateField(_x, _x2) {
    return _ref14.apply(this, arguments);
  };
}();

var getValidationModes = function getValidationModes(mode) {
  return {
    isOnSubmit: !mode || mode === VALIDATION_MODE.onSubmit,
    isOnBlur: mode === VALIDATION_MODE.onBlur,
    isOnChange: mode === VALIDATION_MODE.onChange,
    isOnAll: mode === VALIDATION_MODE.all,
    isOnTouch: mode === VALIDATION_MODE.onTouched
  };
};

var isHTMLElement = function isHTMLElement(value) {
  return value instanceof HTMLElement;
};

var isRadioOrCheckboxFunction = function isRadioOrCheckboxFunction(ref) {
  return isRadioInput(ref) || isCheckBoxInput(ref);
};

var Subscription = /*#__PURE__*/function () {
  function Subscription() {
    _classCallCheck(this, Subscription);

    this.tearDowns = [];
  }

  _createClass(Subscription, [{
    key: "add",
    value: function add(tearDown) {
      this.tearDowns.push(tearDown);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      var _iterator5 = _createForOfIteratorHelper(this.tearDowns),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var teardown = _step5.value;
          teardown();
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      this.tearDowns = [];
    }
  }]);

  return Subscription;
}();

var Subscriber = /*#__PURE__*/function () {
  function Subscriber(observer, subscription) {
    var _this = this;

    _classCallCheck(this, Subscriber);

    this.observer = observer;
    this.closed = false;
    subscription.add(function () {
      return _this.closed = true;
    });
  }

  _createClass(Subscriber, [{
    key: "next",
    value: function next(value) {
      if (!this.closed) {
        this.observer.next(value);
      }
    }
  }]);

  return Subscriber;
}();

var Subject = /*#__PURE__*/function () {
  function Subject() {
    _classCallCheck(this, Subject);

    this.observers = [];
  }

  _createClass(Subject, [{
    key: "next",
    value: function next(value) {
      var _iterator6 = _createForOfIteratorHelper(this.observers),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var observer = _step6.value;
          observer.next(value);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(observer) {
      var subscription = new Subscription();
      var subscriber = new Subscriber(observer, subscription);
      this.observers.push(subscriber);
      return subscription;
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      this.observers = [];
    }
  }]);

  return Subject;
}();

var isWindowUndefined = typeof window === UNDEFINED;

function useForm() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref16$mode = _ref16.mode,
      mode = _ref16$mode === void 0 ? VALIDATION_MODE.onSubmit : _ref16$mode,
      _ref16$reValidateMode = _ref16.reValidateMode,
      reValidateMode = _ref16$reValidateMode === void 0 ? VALIDATION_MODE.onChange : _ref16$reValidateMode,
      resolver = _ref16.resolver,
      context = _ref16.context,
      _ref16$defaultValues = _ref16.defaultValues,
      defaultValues = _ref16$defaultValues === void 0 ? {} : _ref16$defaultValues,
      _ref16$shouldFocusErr = _ref16.shouldFocusError,
      shouldFocusError = _ref16$shouldFocusErr === void 0 ? true : _ref16$shouldFocusErr,
      criteriaMode = _ref16.criteriaMode;

  var fieldsRef = React.useRef({});
  var fieldsNamesRef = React.useRef(new Set());
  var formStateSubjectRef = React.useRef(new Subject());
  var watchSubjectRef = React.useRef(new Subject());
  var controllerSubjectRef = React.useRef(new Subject());
  var fieldArraySubjectRef = React.useRef(new Subject());
  var fieldArrayDefaultValuesRef = React.useRef({});
  var watchFieldsRef = React.useRef(new Set());
  var isMountedRef = React.useRef(false);
  var fieldsWithValidationRef = React.useRef({});
  var validFieldsRef = React.useRef({});
  var defaultValuesRef = React.useRef(defaultValues);
  var isWatchAllRef = React.useRef(false);
  var contextRef = React.useRef(context);
  var resolverRef = React.useRef(resolver);
  var fieldArrayNamesRef = React.useRef(new Set());
  var validationMode = getValidationModes(mode);
  var isValidateAllFieldCriteria = criteriaMode === VALIDATION_MODE.all;

  var _React$useState7 = React.useState({
    isDirty: false,
    isValidating: false,
    dirtyFields: {},
    isSubmitted: false,
    submitCount: 0,
    touchedFields: {},
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: !validationMode.isOnSubmit,
    errors: {}
  }),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      formState = _React$useState8[0],
      setFormState = _React$useState8[1];

  var readFormStateRef = React.useRef({
    isDirty: !isProxyEnabled,
    dirtyFields: !isProxyEnabled,
    touchedFields: !isProxyEnabled,
    isValidating: !isProxyEnabled,
    isValid: !isProxyEnabled,
    errors: !isProxyEnabled
  });
  var formStateRef = React.useRef(formState);
  contextRef.current = context;
  resolverRef.current = resolver;

  var getIsValid = function getIsValid() {
    return formStateRef.current.isValid = deepEqual(validFieldsRef.current, fieldsWithValidationRef.current) && isEmptyObject(formStateRef.current.errors);
  };

  var shouldRenderBaseOnError = React.useCallback(function (name, error) {
    var shouldRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var state = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var isValid = arguments.length > 4 ? arguments[4] : undefined;
    var isWatched = arguments.length > 5 ? arguments[5] : undefined;

    var previousError = _get(formStateRef.current.errors, name);

    var shouldReRender = shouldRender || !deepEqual(previousError, error, true) || readFormStateRef.current.isValid && isUndefined(error) && _get(fieldsWithValidationRef.current, name) && !_get(validFieldsRef.current, name);

    if (error) {
      unset(validFieldsRef.current, name);
      shouldReRender = shouldReRender || !previousError || !deepEqual(previousError, error, true);
      set(formStateRef.current.errors, name, error);
    } else {
      if (_get(fieldsWithValidationRef.current, name) || resolverRef.current) {
        set(validFieldsRef.current, name, true);
        shouldReRender = shouldReRender || previousError;
      }

      unset(formStateRef.current.errors, name);
    }

    if (shouldReRender && !isNullOrUndefined(shouldRender) || !isEmptyObject(state) || isWatched) {
      var updatedFormState = Object.assign(Object.assign({}, state), {
        isValid: resolverRef.current ? !!isValid : getIsValid(),
        errors: formStateRef.current.errors
      });
      formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), updatedFormState);
      formStateSubjectRef.current.next(isWatched ? {} : updatedFormState);
    }

    formStateSubjectRef.current.next({
      isValidating: false
    });
  }, []);
  var setFieldValue = React.useCallback(function (name, rawValue) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var shouldRender = arguments.length > 3 ? arguments[3] : undefined;
    var shouldRegister = arguments.length > 4 ? arguments[4] : undefined;
    shouldRegister && register(name);

    var _f = _get(fieldsRef.current, name, {})._f;

    if (_f) {
      var value = isWeb && isHTMLElement(_f.ref) && isNullOrUndefined(rawValue) ? '' : rawValue;
      _f.value = rawValue;

      if (isRadioInput(_f.ref)) {
        (_f.refs || []).forEach(function (radioRef) {
          return radioRef.checked = radioRef.value === value;
        });
      } else if (isFileInput(_f.ref) && !isString(value)) {
        _f.ref.files = value;
      } else if (isMultipleSelect(_f.ref)) {
        _toConsumableArray(_f.ref.options).forEach(function (selectRef) {
          return selectRef.selected = value.includes(selectRef.value);
        });
      } else if (isCheckBoxInput(_f.ref) && _f.refs) {
        _f.refs.length > 1 ? _f.refs.forEach(function (checkboxRef) {
          return checkboxRef.checked = Array.isArray(value) ? !!value.find(function (data) {
            return data === checkboxRef.value;
          }) : value === checkboxRef.value;
        }) : _f.refs[0].checked = !!value;
      } else {
        _f.ref.value = value;
      }

      if (shouldRender) {
        var values = getFieldsValues(fieldsRef);
        set(values, name, rawValue);
        controllerSubjectRef.current.next({
          values: Object.assign(Object.assign({}, defaultValuesRef.current), values),
          name: name
        });
      }

      options.shouldDirty && updateAndGetDirtyState(name, value);
      options.shouldValidate && trigger(name);
    }
  }, []);
  var getFormIsDirty = React.useCallback(function (name, data) {
    if (readFormStateRef.current.isDirty) {
      var formValues = getFieldsValues(fieldsRef);
      name && data && set(formValues, name, data);
      return !deepEqual(formValues, defaultValuesRef.current);
    }

    return false;
  }, []);
  var updateAndGetDirtyState = React.useCallback(function (name, inputValue) {
    var shouldRender = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    if (readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) {
      var isFieldDirty = !deepEqual(_get(defaultValuesRef.current, name), inputValue);

      var isDirtyFieldExist = _get(formStateRef.current.dirtyFields, name);

      var previousIsDirty = formStateRef.current.isDirty;
      isFieldDirty ? set(formStateRef.current.dirtyFields, name, true) : unset(formStateRef.current.dirtyFields, name);
      formStateRef.current.isDirty = getFormIsDirty();
      var state = {
        isDirty: formStateRef.current.isDirty,
        dirtyFields: formStateRef.current.dirtyFields
      };

      var isChanged = readFormStateRef.current.isDirty && previousIsDirty !== state.isDirty || readFormStateRef.current.dirtyFields && isDirtyFieldExist !== _get(formStateRef.current.dirtyFields, name);

      isChanged && shouldRender && formStateSubjectRef.current.next(state);
      return isChanged ? state : {};
    }

    return {};
  }, []);
  var executeValidation = React.useCallback( /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name, skipReRender) {
      var error;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return validateField(_get(fieldsRef.current, name), isValidateAllFieldCriteria);

            case 2:
              _context2.t0 = name;
              error = _context2.sent[_context2.t0];
              shouldRenderBaseOnError(name, error, skipReRender);
              return _context2.abrupt("return", isUndefined(error));

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref17.apply(this, arguments);
    };
  }(), [isValidateAllFieldCriteria]);
  var executeSchemaOrResolverValidation = React.useCallback( /*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(names) {
      var currentNames,
          _yield$resolverRef$cu,
          errors,
          _iterator7,
          _step7,
          _name,
          _error,
          _args3 = arguments;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              currentNames = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : [];
              _context3.next = 3;
              return resolverRef.current(getFieldsValues(fieldsRef, defaultValuesRef), contextRef.current, {
                criteriaMode: criteriaMode,
                names: currentNames,
                fields: getFields(fieldsNamesRef.current, fieldsRef.current)
              });

            case 3:
              _yield$resolverRef$cu = _context3.sent;
              errors = _yield$resolverRef$cu.errors;
              _iterator7 = _createForOfIteratorHelper(names);

              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  _name = _step7.value;
                  _error = _get(errors, _name);
                  _error ? set(formStateRef.current.errors, _name, _error) : unset(formStateRef.current.errors, _name);
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }

              return _context3.abrupt("return", errors);

            case 8:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x5) {
      return _ref18.apply(this, arguments);
    };
  }(), [criteriaMode]);

  var validateForm = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(fieldsRef) {
      var _name2, field, _f, current, fieldError;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.t0 = _regeneratorRuntime.keys(fieldsRef);

            case 1:
              if ((_context4.t1 = _context4.t0()).done) {
                _context4.next = 18;
                break;
              }

              _name2 = _context4.t1.value;
              field = fieldsRef[_name2];

              if (!field) {
                _context4.next = 16;
                break;
              }

              _f = field._f;
              current = omit(field, '_f');

              if (!_f) {
                _context4.next = 12;
                break;
              }

              _context4.next = 10;
              return validateField(field, isValidateAllFieldCriteria);

            case 10:
              fieldError = _context4.sent;

              if (fieldError[_f.name]) {
                set(formStateRef.current.errors, _f.name, fieldError[_f.name]);
                unset(validFieldsRef.current, _f.name);
              } else if (_get(fieldsWithValidationRef.current, _f.name)) {
                set(validFieldsRef.current, _f.name, true);
                unset(formStateRef.current.errors, _f.name);
              }

            case 12:
              _context4.t2 = current;

              if (!_context4.t2) {
                _context4.next = 16;
                break;
              }

              _context4.next = 16;
              return validateForm(current);

            case 16:
              _context4.next = 1;
              break;

            case 18:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function validateForm(_x6) {
      return _ref19.apply(this, arguments);
    };
  }();

  var trigger = React.useCallback( /*#__PURE__*/function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(name) {
      var fields, isValid;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              fields = isUndefined(name) ? Object.keys(fieldsRef.current) : Array.isArray(name) ? name : [name];
              formStateSubjectRef.current.next({
                isValidating: true
              });

              if (!resolverRef.current) {
                _context6.next = 10;
                break;
              }

              _context6.t0 = isEmptyObject;
              _context6.next = 6;
              return executeSchemaOrResolverValidation(fields, isUndefined(name) ? undefined : fields);

            case 6:
              _context6.t1 = _context6.sent;
              isValid = (0, _context6.t0)(_context6.t1);
              _context6.next = 17;
              break;

            case 10:
              if (!isUndefined(name)) {
                _context6.next = 15;
                break;
              }

              _context6.next = 13;
              return validateForm(fieldsRef.current);

            case 13:
              _context6.next = 17;
              break;

            case 15:
              _context6.next = 17;
              return Promise.all(fields.map( /*#__PURE__*/function () {
                var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(data) {
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return executeValidation(data, null);

                        case 2:
                          return _context5.abrupt("return", _context5.sent);

                        case 3:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }));

                return function (_x8) {
                  return _ref21.apply(this, arguments);
                };
              }()));

            case 17:
              formStateSubjectRef.current.next({
                errors: formStateRef.current.errors,
                isValidating: false,
                isValid: resolverRef.current ? isValid : getIsValid()
              });

            case 18:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    return function (_x7) {
      return _ref20.apply(this, arguments);
    };
  }(), [executeSchemaOrResolverValidation, executeValidation]);
  var setInternalValues = React.useCallback(function (name, value, options) {
    return Object.entries(value).forEach(function (_ref22) {
      var _ref23 = _slicedToArray(_ref22, 2),
          inputKey = _ref23[0],
          inputValue = _ref23[1];

      var fieldName = "".concat(name, ".").concat(inputKey);

      var field = _get(fieldsRef.current, fieldName);

      field && !field._f ? setInternalValues(fieldName, inputValue, options) : setFieldValue(fieldName, inputValue, options, true, !field);
    });
  }, [trigger]);

  var isFieldWatched = function isFieldWatched(name) {
    return isWatchAllRef.current || watchFieldsRef.current.has(name) || watchFieldsRef.current.has((name.match(/\w+/) || [])[0]);
  };

  var updateValidAndValue = function updateValidAndValue(name, options, isWithinRefCallback) {
    var defaultValue;

    var field = _get(fieldsRef.current, name);

    var useFormDefaultValue = _get(defaultValuesRef.current, name);

    if (field && (!isEmptyObject(defaultValuesRef.current) || !isUndefined(field._f.value))) {
      defaultValue = isUndefined(field._f.value) ? useFormDefaultValue : field._f.value;

      if (!isNullOrUndefined(defaultValue)) {
        setFieldValue(name, defaultValue);
      }
    }

    if ((useFormDefaultValue || !useFormDefaultValue && isWithinRefCallback) && options && !validationMode.isOnSubmit && field && readFormStateRef.current.isValid) {
      validateField(field, isValidateAllFieldCriteria).then(function (error) {
        isEmptyObject(error) ? set(validFieldsRef.current, name, true) : unset(validFieldsRef.current, name);
        formStateRef.current.isValid && !isEmptyObject(error) && setFormState(Object.assign(Object.assign({}, formStateRef.current), {
          isValid: getIsValid()
        }));
      });
    }

    return defaultValue;
  };

  var setValue = function setValue(name, value) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    isMountedRef.current = true;

    var field = _get(fieldsRef.current, name);

    var isFieldArray = fieldArrayNamesRef.current.has(name);

    if (isFieldArray) {
      fieldArraySubjectRef.current.next({
        fields: value,
        name: name,
        isReset: true
      });

      if ((readFormStateRef.current.isDirty || readFormStateRef.current.dirtyFields) && options.shouldDirty) {
        set(formStateRef.current.dirtyFields, name, setFieldArrayDirtyFields(value, _get(defaultValuesRef.current, name, []), _get(formStateRef.current.dirtyFields, name, [])));
        formStateSubjectRef.current.next({
          dirtyFields: formStateRef.current.dirtyFields,
          isDirty: getFormIsDirty(name, value)
        });
      }

      !value.length && set(fieldsRef.current, name, []) && set(fieldArrayDefaultValuesRef.current, name, []);
    }

    field && !field._f || isFieldArray ? setInternalValues(name, value, isFieldArray ? {} : options) : setFieldValue(name, value, options, true, !field);
    isFieldWatched(name) && formStateSubjectRef.current.next({});
    watchSubjectRef.current.next({
      name: name,
      value: value
    });
  };

  var handleChange = React.useCallback( /*#__PURE__*/function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref24) {
      var type, target, _ref24$target, value, inputType, name, error, isValid, field, inputValue, isBlurEvent, _getValidationModes, isReValidateOnBlur, isReValidateOnChange, shouldSkipValidation, isWatched, state, shouldRender, _yield$resolverRef$cu2, errors, previousFormIsValid, parentNodeName, currentError;

      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              type = _ref24.type, target = _ref24.target, _ref24$target = _ref24.target, value = _ref24$target.value, inputType = _ref24$target.type;
              name = target.name;
              field = _get(fieldsRef.current, name);

              if (!field) {
                _context7.next = 36;
                break;
              }

              inputValue = inputType ? getFieldValue(field) : undefined;
              inputValue = isUndefined(inputValue) ? value : inputValue;
              isBlurEvent = type === EVENTS.BLUR;
              _getValidationModes = getValidationModes(reValidateMode), isReValidateOnBlur = _getValidationModes.isOnBlur, isReValidateOnChange = _getValidationModes.isOnChange;
              shouldSkipValidation = skipValidation(Object.assign({
                isBlurEvent: isBlurEvent,
                isTouched: !!_get(formStateRef.current.touchedFields, name),
                isSubmitted: formStateRef.current.isSubmitted,
                isReValidateOnBlur: isReValidateOnBlur,
                isReValidateOnChange: isReValidateOnChange
              }, validationMode));
              isWatched = !isBlurEvent && isFieldWatched(name);

              if (!isUndefined(inputValue)) {
                field._f.value = inputValue;
              }

              state = updateAndGetDirtyState(name, field._f.value, false);

              if (isBlurEvent && !_get(formStateRef.current.touchedFields, name)) {
                set(formStateRef.current.touchedFields, name, true);
                readFormStateRef.current.touchedFields && (state.touchedFields = formStateRef.current.touchedFields);
              }

              shouldRender = !isEmptyObject(state) || isWatched;

              if (!shouldSkipValidation) {
                _context7.next = 17;
                break;
              }

              !isBlurEvent && watchSubjectRef.current.next({
                name: name,
                type: type,
                value: inputValue
              });
              return _context7.abrupt("return", shouldRender && formStateSubjectRef.current.next(isWatched ? {} : state));

            case 17:
              formStateSubjectRef.current.next({
                isValidating: true
              });

              if (!resolverRef.current) {
                _context7.next = 30;
                break;
              }

              _context7.next = 21;
              return resolverRef.current(getFieldsValues(fieldsRef, defaultValuesRef), contextRef.current, {
                criteriaMode: criteriaMode,
                fields: getFields([name], fieldsRef.current),
                names: [name]
              });

            case 21:
              _yield$resolverRef$cu2 = _context7.sent;
              errors = _yield$resolverRef$cu2.errors;
              previousFormIsValid = formStateRef.current.isValid;
              error = _get(errors, name);

              if (isCheckBoxInput(target) && !error) {
                parentNodeName = getNodeParentName(name);
                currentError = _get(errors, parentNodeName, {});
                currentError.type && currentError.message && (error = currentError);

                if (currentError || _get(formStateRef.current.errors, parentNodeName)) {
                  name = parentNodeName;
                }
              }

              isValid = isEmptyObject(errors);
              previousFormIsValid !== isValid && (shouldRender = true);
              _context7.next = 34;
              break;

            case 30:
              _context7.next = 32;
              return validateField(field, isValidateAllFieldCriteria);

            case 32:
              _context7.t0 = name;
              error = _context7.sent[_context7.t0];

            case 34:
              !isBlurEvent && watchSubjectRef.current.next({
                name: name,
                type: type,
                value: inputValue
              });
              shouldRenderBaseOnError(name, error, shouldRender, state, isValid, isWatched);

            case 36:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function (_x9) {
      return _ref25.apply(this, arguments);
    };
  }(), []);

  var getValues = function getValues(fieldNames) {
    var values = isMountedRef.current ? getFieldsValues(fieldsRef, defaultValuesRef) : defaultValuesRef.current;
    return isUndefined(fieldNames) ? values : isString(fieldNames) ? _get(values, fieldNames) : fieldNames.map(function (name) {
      return _get(values, name);
    });
  };

  var updateIsValid = React.useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var values,
        previousIsValid,
        _yield$resolverRef$cu3,
        errors,
        _args8 = arguments;

    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            values = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
            previousIsValid = formStateRef.current.isValid;

            if (!resolver) {
              _context8.next = 10;
              break;
            }

            _context8.next = 5;
            return resolverRef.current(Object.assign(Object.assign({}, getFieldsValues(fieldsRef, defaultValuesRef)), values), contextRef.current, {
              criteriaMode: criteriaMode,
              fields: getFields(fieldsNamesRef.current, fieldsRef.current)
            });

          case 5:
            _yield$resolverRef$cu3 = _context8.sent;
            errors = _yield$resolverRef$cu3.errors;
            formStateRef.current.isValid = isEmptyObject(errors);
            _context8.next = 11;
            break;

          case 10:
            getIsValid();

          case 11:
            previousIsValid !== formStateRef.current.isValid && formStateSubjectRef.current.next({
              isValid: formStateRef.current.isValid
            });

          case 12:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  })), [criteriaMode]);

  var clearErrors = function clearErrors(name) {
    name && (Array.isArray(name) ? name : [name]).forEach(function (inputName) {
      return unset(formStateRef.current.errors, inputName);
    });
    formStateSubjectRef.current.next({
      errors: name ? formStateRef.current.errors : {}
    });
  };

  var setError = function setError(name, error, options) {
    var ref = ((_get(fieldsRef.current, name) || {
      _f: {}
    })._f || {}).ref;
    set(formStateRef.current.errors, name, Object.assign(Object.assign({}, error), {
      ref: ref
    }));
    formStateSubjectRef.current.next({
      errors: formStateRef.current.errors,
      isValid: false
    });
    options && options.shouldFocus && ref && ref.focus && ref.focus();
  };

  var watchInternal = React.useCallback(function (fieldNames, defaultValue, isGlobal) {
    var isArrayNames = Array.isArray(fieldNames);
    var fieldValues = isMountedRef.current ? getValues() : isUndefined(defaultValue) ? defaultValuesRef.current : isArrayNames ? defaultValue || {} : _defineProperty({}, fieldNames, defaultValue);

    if (isUndefined(fieldNames)) {
      isGlobal && (isWatchAllRef.current = true);
      return fieldValues;
    }

    var result = [];

    var _iterator8 = _createForOfIteratorHelper(isArrayNames ? fieldNames : [fieldNames]),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var fieldName = _step8.value;
        isGlobal && watchFieldsRef.current.add(fieldName);
        result.push(_get(fieldValues, fieldName));
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }

    return isArrayNames ? result : result[0];
  }, []);

  var watch = function watch(fieldName, defaultValue) {
    return isFunction(fieldName) ? watchSubjectRef.current.subscribe({
      next: function next(info) {
        return fieldName(watchInternal(undefined, defaultValue), info);
      }
    }) : watchInternal(fieldName, defaultValue, true);
  };

  var unregister = function unregister(name) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _iterator9 = _createForOfIteratorHelper(name ? Array.isArray(name) ? name : [name] : Object.keys(fieldsNamesRef.current)),
        _step9;

    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var inputName = _step9.value;
        fieldsNamesRef.current.delete(inputName);
        fieldArrayNamesRef.current.delete(inputName);

        if (_get(fieldsRef.current, inputName)) {
          if (!options.keepIsValid) {
            unset(fieldsWithValidationRef.current, inputName);
            unset(validFieldsRef.current, inputName);
          }

          !options.keepError && unset(formStateRef.current.errors, inputName);
          !options.keepValue && unset(fieldsRef.current, inputName);
          !options.keepDirty && unset(formStateRef.current.dirtyFields, inputName);
          !options.keepTouched && unset(formStateRef.current.touchedFields, inputName);
          !options.keepDefaultValue && unset(defaultValuesRef.current, inputName);
          watchSubjectRef.current.next({
            name: inputName
          });
        }
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }

    formStateSubjectRef.current.next(Object.assign(Object.assign(Object.assign({}, formStateRef.current), !options.keepDirty ? {} : {
      isDirty: getFormIsDirty()
    }), resolverRef.current ? {} : {
      isValid: getIsValid()
    }));

    if (!options.keepIsValid) {
      updateIsValid();
    }
  };

  var registerFieldRef = function registerFieldRef(name, ref, options) {
    var field = _get(fieldsRef.current, name);

    if (field) {
      var isRadioOrCheckbox = isRadioOrCheckboxFunction(ref);

      if (ref === field._f.ref || isWeb && isHTMLElement(field._f.ref) && !isHTMLElement(ref) || isRadioOrCheckbox && Array.isArray(field._f.refs) && compact(field._f.refs).find(function (option) {
        return option === ref;
      })) {
        return;
      }

      field = {
        _f: isRadioOrCheckbox ? Object.assign(Object.assign({}, field._f), {
          refs: [].concat(_toConsumableArray(compact(field._f.refs || []).filter(function (ref) {
            return isHTMLElement(ref) && document.contains(ref);
          })), [ref]),
          ref: {
            type: ref.type,
            name: name
          }
        }) : Object.assign(Object.assign({}, field._f), {
          ref: ref
        })
      };
      set(fieldsRef.current, name, field);
      var defaultValue = updateValidAndValue(name, options, true);

      if (isRadioOrCheckbox && Array.isArray(defaultValue) ? !deepEqual(_get(fieldsRef.current, name)._f.value, defaultValue) : isUndefined(_get(fieldsRef.current, name)._f.value)) {
        _get(fieldsRef.current, name)._f.value = getFieldValue(_get(fieldsRef.current, name));
      }
    }
  };

  var register = React.useCallback(function (name, options) {
    var isInitialRegister = !_get(fieldsRef.current, name);
    set(fieldsRef.current, name, {
      _f: Object.assign(Object.assign(Object.assign({}, isInitialRegister ? {
        ref: {
          name: name
        }
      } : Object.assign({
        ref: (_get(fieldsRef.current, name)._f || {}).ref
      }, _get(fieldsRef.current, name)._f)), {
        name: name
      }), options)
    });
    options && set(fieldsWithValidationRef.current, name, true);
    fieldsNamesRef.current.add(name);
    isInitialRegister && updateValidAndValue(name, options);
    return isWindowUndefined ? {
      name: name
    } : {
      name: name,
      onChange: handleChange,
      onBlur: handleChange,
      ref: function (_ref28) {
        function ref(_x10) {
          return _ref28.apply(this, arguments);
        }

        ref.toString = function () {
          return _ref28.toString();
        };

        return ref;
      }(function (ref) {
        return ref && registerFieldRef(name, ref, options);
      })
    };
  }, [defaultValuesRef.current]);
  var handleSubmit = React.useCallback(function (onValid, onInvalid) {
    return /*#__PURE__*/function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(e) {
        var fieldValues, _yield$resolverRef$cu4, errors, values;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (e && e.preventDefault) {
                  e.preventDefault();
                  e.persist();
                }

                fieldValues = Object.assign(Object.assign({}, defaultValuesRef.current), getFieldsValues(fieldsRef, defaultValuesRef));
                formStateSubjectRef.current.next({
                  isSubmitting: true
                });
                _context9.prev = 3;

                if (!resolverRef.current) {
                  _context9.next = 14;
                  break;
                }

                _context9.next = 7;
                return resolverRef.current(fieldValues, contextRef.current, {
                  criteriaMode: criteriaMode,
                  fields: getFields(fieldsNamesRef.current, fieldsRef.current)
                });

              case 7:
                _yield$resolverRef$cu4 = _context9.sent;
                errors = _yield$resolverRef$cu4.errors;
                values = _yield$resolverRef$cu4.values;
                formStateRef.current.errors = errors;
                fieldValues = values;
                _context9.next = 16;
                break;

              case 14:
                _context9.next = 16;
                return validateForm(fieldsRef.current);

              case 16:
                if (!(isEmptyObject(formStateRef.current.errors) && Object.keys(formStateRef.current.errors).every(function (name) {
                  return _get(fieldValues, name);
                }))) {
                  _context9.next = 22;
                  break;
                }

                formStateSubjectRef.current.next({
                  errors: {},
                  isSubmitting: true
                });
                _context9.next = 20;
                return onValid(fieldValues, e);

              case 20:
                _context9.next = 27;
                break;

              case 22:
                _context9.t0 = onInvalid;

                if (!_context9.t0) {
                  _context9.next = 26;
                  break;
                }

                _context9.next = 26;
                return onInvalid(formStateRef.current.errors, e);

              case 26:
                shouldFocusError && focusFieldBy(fieldsRef.current, function (key) {
                  return _get(formStateRef.current.errors, key);
                }, fieldsNamesRef.current);

              case 27:
                _context9.prev = 27;
                formStateRef.current.isSubmitted = true;
                formStateSubjectRef.current.next({
                  isSubmitted: true,
                  isSubmitting: false,
                  isSubmitSuccessful: isEmptyObject(formStateRef.current.errors),
                  submitCount: formStateRef.current.submitCount + 1,
                  errors: formStateRef.current.errors
                });
                return _context9.finish(27);

              case 31:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, null, [[3,, 27, 31]]);
      }));

      return function (_x11) {
        return _ref29.apply(this, arguments);
      };
    }();
  }, [shouldFocusError, isValidateAllFieldCriteria, criteriaMode]);
  var resetFromState = React.useCallback(function (_ref30) {
    var keepErrors = _ref30.keepErrors,
        keepDirty = _ref30.keepDirty,
        keepIsSubmitted = _ref30.keepIsSubmitted,
        keepTouched = _ref30.keepTouched,
        keepIsValid = _ref30.keepIsValid,
        keepSubmitCount = _ref30.keepSubmitCount;

    if (!keepIsValid) {
      validFieldsRef.current = {};
      fieldsWithValidationRef.current = {};
    }

    watchFieldsRef.current = new Set();
    isWatchAllRef.current = false;
    formStateSubjectRef.current.next({
      submitCount: keepSubmitCount ? formStateRef.current.submitCount : 0,
      isDirty: keepDirty ? formStateRef.current.isDirty : false,
      isSubmitted: keepIsSubmitted ? formStateRef.current.isSubmitted : false,
      isValid: keepIsValid ? formStateRef.current.isValid : !validationMode.isOnSubmit,
      dirtyFields: keepDirty ? formStateRef.current.dirtyFields : {},
      touchedFields: keepTouched ? formStateRef.current.touchedFields : {},
      errors: keepErrors ? formStateRef.current.errors : {},
      isSubmitting: false,
      isSubmitSuccessful: false
    });
  }, []);

  var reset = function reset(values) {
    var keepStateOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var updatedValues = values || defaultValuesRef.current;

    if (isWeb && !keepStateOptions.keepValues) {
      for (var _i3 = 0, _Object$values = Object.values(fieldsRef.current); _i3 < _Object$values.length; _i3++) {
        var field = _Object$values[_i3];

        if (field && field._f) {
          var inputRef = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;

          if (isHTMLElement(inputRef)) {
            try {
              inputRef.closest('form').reset();
              break;
            } catch (_a) {}
          }
        }
      }
    }

    !keepStateOptions.keepDefaultValues && (defaultValuesRef.current = Object.assign({}, updatedValues));

    if (!keepStateOptions.keepValues) {
      fieldsRef.current = {};
      controllerSubjectRef.current.next({
        values: Object.assign({}, updatedValues)
      });
      watchSubjectRef.current.next({
        value: Object.assign({}, updatedValues)
      });
      fieldArraySubjectRef.current.next({
        fields: Object.assign({}, updatedValues),
        isReset: true
      });
    }

    resetFromState(keepStateOptions);
  };

  React.useEffect(function () {
    isMountedRef.current = true;
    var formStateSubscription = formStateSubjectRef.current.subscribe({
      next: function next() {
        var formState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (shouldRenderFormState(formState, readFormStateRef.current, true)) {
          formStateRef.current = Object.assign(Object.assign({}, formStateRef.current), formState);
          setFormState(formStateRef.current);
        }
      }
    });
    var useFieldArraySubscription = fieldArraySubjectRef.current.subscribe({
      next: function next(state) {
        if (state.fields && state.name && readFormStateRef.current.isValid) {
          var values = getFieldsValues(fieldsRef);
          set(values, state.name, state.fields);
          updateIsValid(values);
        }
      }
    });
    resolverRef.current && readFormStateRef.current.isValid && updateIsValid();
    return function () {
      watchSubjectRef.current.unsubscribe();
      formStateSubscription.unsubscribe();
      useFieldArraySubscription.unsubscribe();
    };
  }, []);
  return {
    control: React.useMemo(function () {
      return {
        register: register,
        isWatchAllRef: isWatchAllRef,
        watchFieldsRef: watchFieldsRef,
        getFormIsDirty: getFormIsDirty,
        formStateSubjectRef: formStateSubjectRef,
        fieldArraySubjectRef: fieldArraySubjectRef,
        controllerSubjectRef: controllerSubjectRef,
        watchSubjectRef: watchSubjectRef,
        watchInternal: watchInternal,
        fieldsRef: fieldsRef,
        validFieldsRef: validFieldsRef,
        fieldsWithValidationRef: fieldsWithValidationRef,
        fieldArrayNamesRef: fieldArrayNamesRef,
        readFormStateRef: readFormStateRef,
        formStateRef: formStateRef,
        defaultValuesRef: defaultValuesRef,
        fieldArrayDefaultValuesRef: fieldArrayDefaultValuesRef
      };
    }, []),
    formState: getProxyFormState(isProxyEnabled, formState, readFormStateRef),
    trigger: trigger,
    register: register,
    handleSubmit: handleSubmit,
    watch: React.useCallback(watch, []),
    setValue: React.useCallback(setValue, [setInternalValues]),
    getValues: React.useCallback(getValues, []),
    reset: React.useCallback(reset, []),
    clearErrors: React.useCallback(clearErrors, []),
    unregister: React.useCallback(unregister, []),
    setError: React.useCallback(setError, [])
  };
}

function useWatch(props) {
  var _ref31 = props || {},
      control = _ref31.control,
      name = _ref31.name,
      defaultValue = _ref31.defaultValue;

  var methods = useFormContext();
  var nameRef = React.useRef(name);
  nameRef.current = name;

  var _ref32 = control || methods.control,
      watchInternal = _ref32.watchInternal,
      watchSubjectRef = _ref32.watchSubjectRef;

  var _React$useState9 = React.useState(isUndefined(defaultValue) ? watchInternal(name) : defaultValue),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      value = _React$useState10[0],
      updateValue = _React$useState10[1];

  React.useEffect(function () {
    watchInternal(name);
    var watchSubscription = watchSubjectRef.current.subscribe({
      next: function next(_ref33) {
        var inputName = _ref33.name,
            value = _ref33.value;
        return (!nameRef.current || !inputName || (Array.isArray(nameRef.current) ? nameRef.current : [nameRef.current]).some(function (fieldName) {
          return inputName && fieldName && inputName.startsWith(fieldName);
        })) && updateValue(isString(inputName) && nameRef.current === inputName && !isUndefined(value) ? value : watchInternal(nameRef.current, defaultValue));
      }
    });
    return function () {
      return watchSubscription.unsubscribe();
    };
  }, []);
  return value;
}

export { Controller, FormProvider, appendErrors, _get as get, set, useController, useFieldArray, useForm, useFormContext, useFormState, useWatch };